// Create a new file named LayoutManager.ts and move the following code into it

import { Layer } from './types'
import {
  Section,
  SectionFactory,
  TextSection,
} from './components/sections/TextSection'
import { changeType, StateManager } from './store/StateManager'
import { DomHelper } from './utlis/DomHelper'
import { DomManager } from './managers/DOMManager'
import { IStateChangeInfo } from './managers/UndoManager'
import { CSS_CLASSES } from './constants/CSSClasses'
import { LayoutConfig } from './sampleConfig'

export class LayoutManager {
  private viewport: HTMLElement
  private state:LayoutConfig
  private layerPanel: HTMLElement
  private selectedLayer: {
    element: HTMLElement
    layer: Layer
  } | null
  private stateManger: StateManager
  private layers: Layer[] = []
  private rcIncMultiplier:number = 1

  constructor(parentElement: HTMLElement, layerPanel: HTMLElement) {
    this.viewport = parentElement
    this.layerPanel = layerPanel
    // this.initLayerPanel();
    this.selectedLayer = null
    this.stateManger = StateManager.getInstance()    
    this.state = this.stateManger.getState();
    this.viewport.focus()
  }

  private getMultiplierToSetMinCellSize(curSize:number,maxVal:number):number{
    if(curSize < 0)
      return 1;
    if(curSize * 2 >= maxVal)
      return 2
    else
      return 2 * this.getMultiplierToSetMinCellSize(curSize * 2, maxVal);
  }
  public refreshLayers(){
    const canvas = this.viewport.querySelector('#canvas') as HTMLElement
    const state = this.stateManger.getState();
    const scale = (state.scale)?state.scale:[1,1]
    const zoomValue = this.stateManger.getZoomValue();
    const multiplier = this.stateManger.getMultipler();
    let gridCellSizeX = (this.state.cellWidth / multiplier) * zoomValue * scale[0]
    let gridCellSizeY = (this.state.cellHeight / multiplier) * zoomValue * scale[1]
    if(gridCellSizeX<3 && gridCellSizeX > 0){
      const sizeMul = this.getMultiplierToSetMinCellSize(gridCellSizeX, 3);
      gridCellSizeX = gridCellSizeX * sizeMul;
      gridCellSizeY = gridCellSizeY * sizeMul;
    }
    canvas.style.backgroundSize = `${gridCellSizeX}px ${gridCellSizeY}px`
  }

  public renderLayer(layer: Layer): void {
    this.viewport.style.width = `100%`
    this.viewport.style.height = `100%`
    const canvas = this.viewport.querySelector('#canvas') as HTMLElement
    const zoomValue = this.stateManger.getZoomValue();    
    const scale = (this.state.scale)?this.state.scale:[1,1]
    const multiplier = this.stateManger.getMultipler();
    let gridCellSizeX = (this.state.cellWidth / multiplier) * zoomValue * scale[0]
    let gridCellSizeY = (this.state.cellHeight / multiplier) * zoomValue * scale[1]
    if(gridCellSizeX<3){
      const sizeMul = this.getMultiplierToSetMinCellSize(gridCellSizeX, 3);
      gridCellSizeX = gridCellSizeX * sizeMul;
      gridCellSizeY = gridCellSizeY * sizeMul;
    }
    canvas.style.backgroundSize = `${gridCellSizeX}px ${gridCellSizeY}px`
    const table = this.viewport.querySelector('table') ||  document.createElement('table')
    table.classList.add("layer-grid");
    table.innerHTML = '';
    const viewportWidth = this.viewport.clientWidth
    const viewportHeight = this.viewport.clientHeight
    const cellWidth = 100 / layer.cols;
    const cellHeight = 100 / layer.rows;
    
    for (let i = 0; i < layer.rows; i++) {
      const row = document.createElement('tr')
      for (let j = 0; j < layer.cols; j++) {
        const cell = document.createElement('td')
        cell.dataset.row = i.toString()
        cell.dataset.col = j.toString()
        cell.style.width = `${cellWidth}%`
        cell.style.height = `${cellHeight}%`
        //need to delete these two line in prod
        // cell.textContent = `${i}:${j}`
        // cell.style.fontSize = "12px"
        cell.addEventListener('dragover', (e) => e.preventDefault())
        // cell.addEventListener('drop', (e) => this.handleDrop(e, layer));
        row.appendChild(cell)
      }
      table.appendChild(row)
    }
    // this.viewport.innerHTML = '';
    //this.viewport.appendChild(table)
    this.renderContainers(layer)
  }

  private renderContainers(layer: Layer): void {
    layer.containers.forEach((container) => {
      const cell: HTMLTableCellElement = this.viewport.querySelector(
        `td[data-row="${container.row}"][data-col="${container.col}"]`,
      ) as HTMLTableCellElement
      if (cell) {
        cell.colSpan = container.width
        cell.rowSpan = container.height
        let dropContainer = document.createElement('div')
        dropContainer.style.position = 'relative'
        dropContainer.style.height = '100%'
        dropContainer.style.width = '100%'
        dropContainer.style.background = 'lightgrey'
        cell.appendChild(dropContainer)
      }
    })
  }

  public addLayer(rcMultiplier:number) {
    this.state = StateManager.getInstance().getState()
    const layer: Layer = {
      name: 'Layer 1',
      rows: this.state.rowCount,
      cols: this.state.colCount,
      containers: [],
    }
    this.rcIncMultiplier = rcMultiplier
    this.layers.push(layer)
    // this.initLayerPanel();
    this.renderLayer(layer)
  }
  
  public static addSections(sections: Section[]) {
    const state = StateManager.getInstance().getState()
    const sectionAdded: Section[] = []
    sections.forEach((s: Section) => {
      const sectionObj = this.addSection(s)
      sectionAdded.push(sectionObj)
    })
    const oldState = StateManager.getInstance().getState()
    StateManager.getInstance().setState({
      state: { ...oldState, sections: sectionAdded },
      changeType: changeType.UPDATE_ALL_Section,
    })
  }

  public static addSection(s: Section) {
    const state = StateManager.getInstance().getState()
    const sectionObj = SectionFactory.getSectionByType(s)!
    const { row, col, rowCount, colCount } = s
    let el = SectionFactory.createSectionElement()
    let sectionEL = sectionObj?.render()!
    el.appendChild(sectionEL)
    if(sectionObj.isLocked){
      el.classList.add(CSS_CLASSES.LOCKED);
    }
    el.id = s.id ?s.id: el.id
    sectionObj.id = el.id
    el.style.top = state.cellHeight * row + 'px'
    el.style.left = state.cellWidth * col + 'px'
    el.style.width = state.cellWidth * colCount + 'px'
    el.style.height = state.cellHeight * rowCount + 'px'
    if (s.selected) {
      el.classList.add('selected')
    }
    document.querySelector('.draggable-container')?.appendChild(el)
    ;(el as any)['sectionObj'] = sectionObj
    s.propInfo?.forEach((prop) => {
      DomHelper.setBindingValue(
        sectionEL.querySelector('.section'),
        prop.binding,
        prop.value,
      )
    })

    DomManager.getInstance().addResizeHandles(el)
    return sectionObj
  }

  public static syncStateToDOM(stateInfo: IStateChangeInfo) {
    // Get all current DOM sections
    const currentDomSections = Array.from(
      document.querySelectorAll('.layout-drag-item'),
    ).map((el) => el.id)

    // Create a Set for tracking processed sections
    const processedSections = new Set<string>()
    // First, update all sections that exist in state
    stateInfo.state.sections.forEach((section) => {
      try {
        // If section exists in DOM, update it
        if (currentDomSections.includes(section.id)) {
          this.syncSectionToDom(section, stateInfo.state, stateInfo.zoomValue, stateInfo.multiplier)
        } else {
          // If section doesn't exist in DOM, add it
          this.addSection(section)
        }
        processedSections.add(section.id)
      } catch (error) {
        // If section doesn't exist in DOM, add it
        this.addSection(section)
        processedSections.add(section.id)
      }
    })

    // Remove any DOM sections that don't exist in state
    currentDomSections.forEach((domId) => {
      if (!processedSections.has(domId)) {
        const elementToRemove = document.querySelector(
          `.layout-drag-item#${CSS.escape(domId)}`,
        )
        if (elementToRemove) {
          elementToRemove.remove()
        }
      }
    })


    // maintain the order of the sections
    const sections = stateInfo.state.sections;
    const container = document.querySelector('.draggable-container');
    if (container) {
      const orderedSections = sections.map(section => document.getElementById(section.id)).filter(el => el !== null) as any;
      container.replaceChildren(...orderedSections);
    }
    DomHelper.focusViewport()
  }
  public static scaleFontSizes(html: string, newSize: number, oldSize:number): string {
    const fontSizeRegex = /font-size:\s*([\d.]+)(px|em|rem|%|pt)/gi;
    let newHtml =  html.replace(fontSizeRegex, (match, value, unit) => {
      const fontSize = ((parseFloat(value) / oldSize) * newSize).toFixed(10); 
      return `font-size: ${fontSize}${unit}`;
    });
    console.log(newHtml)
    return newHtml;
  }
  
  public static syncSectionToDom(section: Section, state?:LayoutConfig, zoomValue?:number, multiplier?:number) {
    if(!state || !zoomValue || !multiplier){
      const stateManager = StateManager.getInstance();
      state = stateManager.getState();
      zoomValue = stateManager.getZoomValue();
      multiplier = stateManager.getMultipler();
    }
    const { row, col, rowCount, colCount } = section
    try {      
      const scale = (state.scale)?state.scale:[1,1]
      const sectionDiv = DomHelper.getSectionDiv(section.id)
      const sectionBoundary = sectionDiv.getBoundingClientRect(); 
      sectionDiv.style.top = (state.cellHeight / multiplier) * scale[1] *  zoomValue * row + 'px'
      sectionDiv.style.left = (state.cellWidth / multiplier) * scale[0] * zoomValue * col + 'px'      
      DomManager.setZoom(sectionDiv as HTMLDivElement, [zoomValue * scale[0],zoomValue * scale[1]])
      // Update selection state
      if (section.selected) {
        sectionDiv.classList.add('selected')
      } else {
        sectionDiv.classList.remove('selected')
      }

      // Update section object reference
      const oldSectionObj = (sectionDiv as any)['sectionObj']
      oldSectionObj.row = Math.round(row)
      oldSectionObj.col = Math.round(col)
      oldSectionObj.rowCount = Math.round(rowCount)
      oldSectionObj.colCount = Math.round(colCount)
      oldSectionObj.selected = section.selected
      oldSectionObj.options = section.options || null
      
      //handle SVG Types section
      if (section.type === 'line' || section.type === 'arrow') {
        const sectionObj = SectionFactory.getSectionByType(section)
        sectionDiv.replaceChild(sectionObj!.render(), sectionDiv.firstChild!);
        (sectionDiv as any)['sectionObj'] = sectionObj;
      }

      //rerender the inner HTML
      if(section.type =='option' || section.type == 'textbox' || section.type == 'line'){
        const innerSection  = sectionDiv.querySelector(".wrapper") as HTMLDivElement;
        const sectionObj = SectionFactory.getSectionByType(section);
        innerSection.innerHTML= '';
        (sectionDiv as any)['sectionObj'] = sectionObj;
        innerSection.parentElement?.replaceChild(sectionObj!.render(), innerSection);
      }
      // Update properties
      section.propInfo?.forEach((p) => {
        DomHelper.setBindingValue(
          sectionDiv.querySelector('.section'),
          p.binding,
          p.value,
        )
      })
    } catch (error) {
      console.warn(`Section ${section.id} not found in DOM, will be added`)
      throw error // Re-throw to handle in parent method
    }
  }

  public static removeSection(sectionId: string) {
    const stateManager = StateManager.getInstance();
    const currentState = stateManager.getState();
    const sectionToRemove = currentState.sections.find(section => section.id === sectionId);

    if (!sectionToRemove) {
      console.warn(`Section with ID ${sectionId} not found in state.`);
      return;
    }

    const updatedSections = currentState.sections.filter(section => section.id !== sectionId);
    const elementToRemove = document.querySelector(`.layout-drag-item#${CSS.escape(sectionId)}`);

    if (elementToRemove) {
      elementToRemove.remove();
    } else {
      console.warn(`Section with ID ${sectionId} not found in DOM.`);
    }
    DomHelper.focusViewport();

    stateManager.setState({
      state: { ...currentState, sections: updatedSections },
      changeType: changeType.REMOVE_SECTION,
    });
  }

  public static removeSections(sectionIds: string[]) {
    const stateManager = StateManager.getInstance();
    const currentState = stateManager.getState();
    const updatedSections = currentState.sections.filter(section => !sectionIds.includes(section.id));

    sectionIds.forEach(sectionId => {
      const elementToRemove = document.querySelector(`.layout-drag-item#${CSS.escape(sectionId)}`);
      if (elementToRemove) {
        elementToRemove.remove();
      } else {
        console.warn(`Section with ID ${sectionId} not found in DOM.`);
      }
    });

    DomHelper.focusViewport();

    stateManager.setState({
      sectionIds,
      state: { ...currentState, sections: updatedSections },
      changeType: changeType.REMOVE_SECTION,
    });
  }

  public static bringToFront(sectionId: string) {
    
    const sectionEL = document.getElementById(sectionId);
    if (!sectionEL) {
      console.warn(`Section with ID ${sectionId} not found in DOM.`);
      return;
    }

    const container = document.querySelector('.draggable-container');
    if (!container) {
      console.warn('Draggable container not found in DOM.');
      return;
    }
    container.appendChild(sectionEL);    

  }

  public static sendToBack(sectionId: string) {
    const sectionEL = document.getElementById(sectionId);
    if (!sectionEL) {
      console.warn(`Section with ID ${sectionId} not found in DOM.`);
      return;
    }

    const container = document.querySelector('.draggable-container');
    if (!container) {
      console.warn('Draggable container not found in DOM.');
      return;
    }
    container.prepend(sectionEL);
  }

  public destroy() {
    this.viewport.innerHTML = ''
  }
}


(window as any).LayoutManager = LayoutManager  